global.conmed = global.conmed || {};

conmed.eventsFilter = function ($) {
    'use strict';

    var that = {
        selectors: {
            //regionList = '.region-selector'
        }
    };

    that.init = function () {

        $('#region').on('change', function (e) {
            FilterEvents(e);
        });

        $('#resourcetype').on('change', function (e) {
            FilterEvents(e);
        });

        $('#eventtype').on('change', function (e) {
            FilterEvents(e);
        });

        $('#specialties').on('change', function (e) {
            FilterEvents(e);
        });

        $('#roles').on('change', function (e) {
            FilterEvents(e);
        });

        $('#tags').on('change', function (e) {
            FilterEvents(e);
        });

        function FilterEvents(e) {
            console.log('[DocumentsFilter] FilterEvents triggered');

            // Prevent any form submission or default behavior
            if (e) {
                e.preventDefault();
                e.stopPropagation();
            }

            var selectedRegion = $('#region').children("option:selected").val();
            var selectedEventType = $('#eventtype').children("option:selected").val();
            var selectedResourceType = $('#resourcetype').children("option:selected").val();
            var selectedRoles = $('#roles').children("option:selected").val();
            var selectedSpecialties = $('#specialties').children("option:selected").val();
            var selectedTags = $('#tags').children("option:selected").val();

            console.log('[DocumentsFilter] Selected values:', {
                resourceType: selectedResourceType,
                specialties: selectedSpecialties,
                roles: selectedRoles
            });

            var pathname = window.location.pathname; // Returns path only (/path/example.html)
            var url = window.location.href;     // Returns full URL (https://example.com/path/example.html)
            var origin = window.location.origin;   // Returns base URL (https://example.com)

            var filter = "";
            var regionFilter = "";
            var eventTypeFilter = "";
            var resourceTypeFilter = "";
            var specialtiesFilter = "";
            var rolesFilter = "";
            var tagsFilter = "";

            if (selectedRegion !== "" && selectedRegion !== undefined)
                regionFilter = 'region=' + selectedRegion + '&';

            if (selectedEventType !== "" && selectedEventType !== undefined)
                eventTypeFilter = 'eventtype=' + selectedEventType + '&';

            if (selectedSpecialties !== "" && selectedSpecialties !== undefined)
                specialtiesFilter = 'specialties=' + selectedSpecialties + '&';

            if (selectedRoles !== "" && selectedRoles !== undefined)
                rolesFilter = 'roles=' + selectedRoles + '&';

            if (selectedResourceType !== "" && selectedResourceType !== undefined)
                resourceTypeFilter = 'resourcetype=' + selectedResourceType + '&';

            if (selectedTags !== "" && selectedTags !== undefined)
                tagsFilter = 'tags=' + selectedTags + '&';

            // Check if documents container exists for AJAX filtering
            var $documentsSection = $('.documents-card-section');
            var $documentsResults = $('#documents-results');

            console.log('[DocumentsFilter] Documents section found:', $documentsSection.length > 0);
            console.log('[DocumentsFilter] Documents results found:', $documentsResults.length > 0);
            console.log('[DocumentsFilter] AJAX URL from data attribute:', $documentsSection.data('ajax-url'));

            if ($documentsSection.length && $documentsResults.length) {
                // Use AJAX for documents filtering (no page reload)
                var ajaxUrl = $documentsSection.data('ajax-url');
                console.log('[DocumentsFilter] Attempting AJAX mode, ajaxUrl:', ajaxUrl);

                if (ajaxUrl) {
                    // Skip language prefix for .ashx handlers
                    if (!ajaxUrl.endsWith('.ashx')) {
                        // Handle language prefix in URL (e.g., /es-mx/api/documents/filter)
                        var pathParts = pathname.split('/').filter(function(p) { return p; });
                        if (pathParts.length > 0 && pathParts[0].match(/^[a-z]{2}(-[a-z]{2})?$/i)) {
                            ajaxUrl = '/' + pathParts[0] + ajaxUrl;
                            console.log('[DocumentsFilter] Language prefix detected, adjusted URL:', ajaxUrl);
                        }
                    }
                    var ajaxParams = {
                        resourcetype: selectedResourceType || '',
                        specialties: selectedSpecialties || '',
                        roles: selectedRoles || ''
                    };

                    console.log('[DocumentsFilter] Making AJAX request to:', ajaxUrl, 'with params:', ajaxParams);

                    // Show loading state
                    $documentsResults.css('opacity', '0.5');

                    $.ajax({
                        url: ajaxUrl,
                        type: 'GET',
                        data: ajaxParams,
                        success: function (html) {
                            console.log('[DocumentsFilter] AJAX success, received HTML length:', html.length);
                            $documentsResults.html(html);
                            $documentsResults.css('opacity', '1');

                            // Update URL without reload for bookmarking/sharing
                            var newUrl = pathname;
                            var queryParams = [];
                            if (selectedResourceType) queryParams.push('resourcetype=' + selectedResourceType);
                            if (selectedSpecialties) queryParams.push('specialties=' + selectedSpecialties);
                            if (selectedRoles) queryParams.push('roles=' + selectedRoles);
                            if (queryParams.length > 0) {
                                newUrl += '?' + queryParams.join('&');
                            }
                            window.history.pushState({ path: newUrl }, '', newUrl);
                            console.log('[DocumentsFilter] URL updated to:', newUrl);
                        },
                        error: function (xhr, status, error) {
                            $documentsResults.css('opacity', '1');
                            console.error('[DocumentsFilter] AJAX error:', status, error, xhr.responseText);
                        }
                    });
                    return;
                } else {
                    console.log('[DocumentsFilter] No ajax-url data attribute found, falling back to page reload');
                }
            } else {
                console.log('[DocumentsFilter] Documents container not found, checking for blogs container');
            }

            // Check if blogs container exists for AJAX filtering
            var $blogsSection = $('.blog-card-section');
            var $blogsResults = $('#blogs-results');

            console.log('[BlogsFilter] Blogs section found:', $blogsSection.length > 0);
            console.log('[BlogsFilter] Blogs results found:', $blogsResults.length > 0);
            console.log('[BlogsFilter] AJAX URL from data attribute:', $blogsSection.data('ajax-url'));

            if ($blogsSection.length && $blogsResults.length) {
                // Use AJAX for blogs filtering (no page reload)
                var blogsAjaxUrl = $blogsSection.data('ajax-url');
                console.log('[BlogsFilter] Attempting AJAX mode, ajaxUrl:', blogsAjaxUrl);

                if (blogsAjaxUrl) {
                    // Skip language prefix for .ashx handlers
                    if (!blogsAjaxUrl.endsWith('.ashx')) {
                        // Handle language prefix in URL (e.g., /es-mx/api/blogs/filter)
                        var pathParts = pathname.split('/').filter(function(p) { return p; });
                        if (pathParts.length > 0 && pathParts[0].match(/^[a-z]{2}(-[a-z]{2})?$/i)) {
                            blogsAjaxUrl = '/' + pathParts[0] + blogsAjaxUrl;
                            console.log('[BlogsFilter] Language prefix detected, adjusted URL:', blogsAjaxUrl);
                        }
                    }
                    var blogsAjaxParams = {
                        tags: selectedTags || '',
                        specialties: selectedSpecialties || '',
                        roles: selectedRoles || ''
                    };

                    console.log('[BlogsFilter] Making AJAX request to:', blogsAjaxUrl, 'with params:', blogsAjaxParams);

                    // Show loading state
                    $blogsResults.css('opacity', '0.5');

                    $.ajax({
                        url: blogsAjaxUrl,
                        type: 'GET',
                        data: blogsAjaxParams,
                        success: function (html) {
                            console.log('[BlogsFilter] AJAX success, received HTML length:', html.length);
                            $blogsResults.html(html);
                            $blogsResults.css('opacity', '1');

                            // Update URL without reload for bookmarking/sharing
                            var newUrl = pathname;
                            var queryParams = [];
                            if (selectedTags) queryParams.push('tags=' + selectedTags);
                            if (selectedSpecialties) queryParams.push('specialties=' + selectedSpecialties);
                            if (selectedRoles) queryParams.push('roles=' + selectedRoles);
                            if (queryParams.length > 0) {
                                newUrl += '?' + queryParams.join('&');
                            }
                            window.history.pushState({ path: newUrl }, '', newUrl);
                            console.log('[BlogsFilter] URL updated to:', newUrl);
                        },
                        error: function (xhr, status, error) {
                            $blogsResults.css('opacity', '1');
                            console.error('[BlogsFilter] AJAX error:', status, error, xhr.responseText);
                        }
                    });
                    return;
                } else {
                    console.log('[BlogsFilter] No ajax-url data attribute found, falling back to page reload');
                }
            } else {
                console.log('[BlogsFilter] Blogs container not found, falling back to page reload');
            }

            // Fallback to full page reload for other filter containers
            console.log('[Filter] Using page reload fallback');
            filter = '?' + regionFilter + eventTypeFilter + specialtiesFilter + rolesFilter + resourceTypeFilter + tagsFilter;

            window.location = origin + pathname + filter;

        }



        function getUrlVars() {
            var vars = [], hash;

            var hashes = window.location.href.slice(window.location.href.indexOf('?') + 1).split('&');

            for (var i = 0; i < hashes.length; i++) {
                hash = hashes[i].split('=');
                vars.push(hash[0]);
                vars[hash[0]] = hash[1];
            }
            return vars;
        }

        function getQueryVariable(url, variable) {

            var query = url.split('?')[1];

            var vars = query.split('&');

            for (var i = 0; i < vars.length; i++) {
                var pair = vars[i].split('=');
                if (pair[0] == variable) {
                    return pair[1];
                }
            }

            return false;
        }
    };

    return that;
}(jQuery);